export const getMediaRatio = (element: HTMLImageElement | HTMLVideoElement): number => {
  const { width, height } = element instanceof HTMLImageElement 
    ? { width: element.naturalWidth, height: element.naturalHeight }
    : { width: element.videoWidth, height: element.videoHeight };
    
  return width / height;
};

export const isVerticalMedia = (ratio: number): boolean => {
  return ratio < 1;
}; 